<!-- <button (click)="test()">Test</button>
<button (click)="testSuccess()">Test Suu</button> -->
<app-offline-banner></app-offline-banner>
@if (!isContentLoading && !isLoading) {
  <router-outlet></router-outlet>
}
